import { useEffect, useState } from "react";
import _ from "lodash";
import { Col, Modal, Row } from "react-bootstrap";
import { getUtilitiesEAM } from "../../../apis/apiEAM";
import { catalogByPart } from "../../../apis";
import { CatalogueInput } from "../../JSONForms/PreviewForm/CatalogueInput";
import { MCSelect } from "../../MainComponents/Select/Select";
import { MCButton } from "../../MainComponents/Button/Button";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import Icon from "../../Icon/Icon";
import { useTranslation } from "react-i18next";
import { fillIfIsCatalogue } from "../../JSONForms/PreviewForm/formStarter";
import { Box, Checkbox, CircularProgress, FormControlLabel, Typography } from "@mui/material";
import { EGSwitch } from "../../MainComponents/Switch/Switch";
import { EGBasicSelect } from "../../MainComponents/Select/EGBasicSelect";

const selectAllPrefix = "type::*";

const EveryValue = ({
  value,
  catalogueInit,
  catDataInit,
  onChange = () => {},
}) => {

  const [catalogue, setCatalogue] = useState(catalogueInit);
  const [catData, setCatData] = useState(catDataInit);
  const [isLoading, setIsLoading] = useState(true);

   useEffect(() => {
    if (value && catalogueInit && catDataInit) {
      setIsLoading(true);
      const newData = _.cloneDeep(catDataInit);
      _.set(newData, `0.${newData[0]?.catalogue}`, value);
      fillIfIsCatalogue(catalogueInit, newData).then((resp) => {
        setCatalogue(resp);
        setCatData(newData);
        setIsLoading(false);
      });
    } else {
      setCatalogue(catalogueInit);
      setCatData(catDataInit);
      setIsLoading(false);
    }
  }, [catalogueInit, catDataInit]);

  useEffect(() => {
    if (catalogue && catData) {
      onChange(catData[0][catalogue[0].catalogue], catalogue[0].label);
    }
  }, [catalogue, catData]);

  
  return (
    <div>
      {isLoading ? (
        <Box sx={{ display: "grid", placeContent: "center", marginBottom: 1 }}>
          <CircularProgress />
        </Box>
      ) : (
        catalogue && catData && (
          <Row className="catalogue-container-single">
            <CatalogueInput
              schema={catalogue[0]}
              scope={catalogue[0]}
              value={catData[0][catalogue[0].catalogue]}
              catalogue={catalogue[0].catalogue}
              isOwn={catalogue[0].isOwn}
              entireSchema={catalogue}
              entireFormData={catData}
              setSchemaState={setCatalogue}
              setFormData={setCatData}
              pathSchema={"0"}
              pathData={"0"}
              returnValidClass={() => {}}
              handleValidate={() => {}}
            />
          </Row>
        )
      )}
    </div>
  );
};

export const ModalSegmentCatalogue = ({
  show,
  onHide,
  scope,
  path,
  handleAddChild,
  handleEditValues,
  utilitiesCatalogues,
  target="add" // add | edit
}) => {

  const { gTheme } = useSelector((state) => state.theme);
  const [t] = useTranslation("users");

  const [selectedCatalogue, setSelectedCatalogue] = useState(null);
  const [catalogue, setCatalogue] = useState(null);
  const [catData, setCatData] = useState(null);
  const [values, setValues] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [catalogueInUtilities, setCatalogueInUtilities] = useState(true);
  const [rerender, setRerender] = useState(false);
  const [selectAll, setSelectAll] = useState((scope?.value === selectAllPrefix && target === "edit") ? true : false);
  // const location = useLocation();

  // Verifica si estamos en la ruta /segments/new
  // const isSegmentsNewRoute = location.pathname === '/segments/new';

  useEffect(() => {
    if (rerender) {
      setRerender(false);
    }
  }, [rerender]);

  useEffect(() => {
    if (target === "edit") {
      const splitedField = scope?.field?.split("::");
      const catalogue = splitedField[splitedField.length - 1];
      const catalogueInUtilities = utilitiesCatalogues.find((item) => item.catalogue === catalogue)
      setSelectedCatalogue(catalogueInUtilities ?? null);
      setCatalogueInUtilities(!!catalogueInUtilities);
      if (selectAll) {
        setValues([]);
      } else {
        setValues(catalogueInUtilities ? scope?.value : []);
      }
    } else {
      setValues([]);
    }
  }, []);

  useEffect(() => {
    if (selectedCatalogue) {
      setCatalogue(null);
      setCatData(null);

      buildCatalogueAndData(selectedCatalogue).then(({ catalogue, data }) => {
        setCatalogue([catalogue]);
        setCatData([data]);
        setIsLoading(false);
      })
      .catch(console.log)
      .finally(() => {
        setIsLoading(false)
      });
    } else {
      setCatalogue(null);
      setCatData(null);
    }
  }, [selectedCatalogue]);

  // initialize values #EDITION
  const buildCatalogueAndData = async (selectedCatalogue) => {
    const resp = await catalogByPart({
      is_own: selectedCatalogue.isOwn,
      catalogue: selectedCatalogue.catalogue,
      path: "/",
    });

    let children = [...resp.data];
    let objCatalogue = {
      key: `C::${selectedCatalogue.isOwn ? "OWN" : "EG"}::${selectedCatalogue.catalogue}`,
      type: "catalog-select",
      label: selectedCatalogue.label,
      placeholder: t("segmentEdit.support_text"),
      required: false,
      sensitive: false,
      scope: "/",
      selected: "",
      isOwn: selectedCatalogue.isOwn,
      catalogue: selectedCatalogue.catalogue,
      children: children,
    };
    let objCatData = {
      [selectedCatalogue.catalogue]: "",
      catalogue: selectedCatalogue.catalogue,
      isOwn: selectedCatalogue.isOwn,
      sensitive: false,
    };
    return { catalogue: objCatalogue, data: objCatData };
  };

  const handleCatalogueChange = (e) => {
    const selectedKey = e.target.value;
    const selectedObj = utilitiesCatalogues.find(item => item.key === selectedKey);
    setValues([]);
    setSelectedCatalogue(selectedObj);
  }

  const handleValues = (val, label, idx) => {
    if (val) {
      const newValues = _.cloneDeep(values);
      newValues[idx] = val;
      setValues(newValues);
    }
  };

  const handleDeleteValue = (idx) => {
    const newValues = _.cloneDeep(values);
    newValues.splice(idx, 1);
    setValues(newValues);
    setRerender(true);
  };

  const handleAddChildLocal = () => {
    const cleanedValues = [...new Set(values.filter(str => str !== ""))];
    const child = {
      child: null,
      field: catalogue[0].key,
      value: selectAll ? selectAllPrefix : cleanedValues,
      label: catalogue[0].label,
    };
    handleAddChild(path, child);
    onHide();
  };

  const handleEditValuesLocal = () => {
    const cleanedValues = [...new Set(values.filter(str => str !== ""))];
    const child = {
      child: scope.child,
      field: catalogue[0].key,
      value: selectAll ? selectAllPrefix : cleanedValues,
      label: catalogue[0].label,
    };
    handleEditValues(path, child);
    onHide();
  };
  
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      className={`${gTheme !== "light" ? "dark-mode" : ""} `}
      centered
      scrollable
      // contentClassName={isSegmentsNewRoute ? 'modal-content-visible' : 'modal-content-hidden'}
    >
      <Modal.Header
        // closeButton
        className={`${gTheme !== "light" ? "btn-close-white" : ""} border-0 d-flex justify-content-between`}
      >
        <Modal.Title>{ target === "edit" ? t("segmentEdit.edit_values") : t("segmentCatalogue.add_segment")}</Modal.Title>
        <FormControlLabel labelPlacement="start" disabled={!selectedCatalogue} control={<EGSwitch checked={selectAll} onChange={(e)=>setSelectAll(e.target.checked)} size="small" />} label="TODOS" />
      </Modal.Header>
      {(utilitiesCatalogues && catalogueInUtilities) ? (
        <div className="py-2 pt-4">
          <EGBasicSelect
            options={utilitiesCatalogues}
            value={selectedCatalogue?.key ?? ""}
            onChange={handleCatalogueChange} 
            optionLabel="label"
            optionValue="key"
            />
        </div>
      ) : (
        <h6>No se encontro el catalogo en el formulario</h6>
      )}

      <Row>
        {Array.isArray(values) && !selectAll &&
          values.map((item, idx) => (
            <Col sm={1} md={4} key={idx} className="pb-2">
              <div className="dyTheme1 dyBorder1 rounded">
                <div className="d-flex justify-content-end pe-1 pt-2" onClick={() => handleDeleteValue(idx)}>
                  <Icon
                    name="cancel_circle"
                    className="pointer"
                  />
                </div>
                <hr className=" mt-1 " />
                <EveryValue
                  value={item}
                  catalogueInit={catalogue}
                  catDataInit={catData}
                  onChange={(val, label) => handleValues(val, label, idx)}
                />
              </div>
            </Col>
          ))}
      </Row>

      <div className="d-flex justify-content-end">
        <MCButton
          label={t("segmentCatalogue.cancel")}
          variant="danger"
          outline
          className="me-2"
          onClick={onHide}
        />
        {selectedCatalogue && !selectAll && (
          <MCButton
            label={t("segmentCatalogue.add_filter")}
            variant="primary"
            outline
            className="me-2"
            onClick={() => setValues([...values, ""])}
          />
        )}
        {(values.length > 0 || selectAll) && (
          <MCButton
            label={t("segmentCatalogue.save")}
            variant="success"
            outline
            onClick={target === "edit" ? handleEditValuesLocal : handleAddChildLocal}
          />
        )}
      </div>
    </Modal>
  );
};
